<template>

  <div>
    <m-icon v-if="item.children.length !== 0" class="m-0  mr-2" dir="ltr"
            :icon="item.icon_class"/>
    <b-dropdown :text="item.name" variant="transparent" class="rounded m-0 p-0" v-if="item.children.length !== 0">

      <b-nav-item class="px-3" dir="ltr" :href="child.url" v-for="child in item.children" :key="child.id">
        {{ child.name }}
        <m-icon class="m-0  mr-2" dir="ltr" :icon="child.icon_class"/>
      </b-nav-item>
    </b-dropdown>

    <b-nav-item :href="item.url" class="" dir="ltr" v-else>{{ item.name }}
      <m-icon class="m-0 " dir="ltr" :icon="item.icon_class"/>
    </b-nav-item>

  </div>

</template>

<script>
export default {
  name: "NavMenuItem",
  props: ['item'],
}
</script>

<style scoped>
</style>